import { createSelector } from 'reselect';

const selectenvironments = (state: any) => state.environments;


export const selectenvironmentsCurrentItem = createSelector([selectenvironments], (environments) => environments.current);

export const selectenvironmentsListItems = createSelector([selectenvironments], (environments) => environments.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectenvironmentsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectenvironmentsQueryItems = createSelector([selectenvironments], (environments) => environments.query);

export const selectenvironmentsCreatedItem = createSelector([selectenvironments], (environments) => environments.create);

export const selectenvironmentsUpdatedItem = createSelector([selectenvironments], (environments) => environments.update);

export const selectenvironmentsReadItem = createSelector([selectenvironments], (environments) => environments.read);

export const selectenvironmentsDeletedItem = createSelector([selectenvironments], (environments) => environments.delete);

export const selectenvironmentsSearchedItems = createSelector([selectenvironments], (environments) => environments.search);

export const selectenvironmentsItemsCount = createSelector([selectenvironments], (environments) => environments.count);

export const selectenvironmentsItemsFilter = createSelector([selectenvironments], (environments) => environments.filter);